import { API, axiosInstance } from "lib";

export const getLedgerStatementData = (data={}) => {
  return axiosInstance
    .post(API.GET_LEDGER_STATEMENT , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};

export const adjustBalanceApi = (data={}) => {
  return axiosInstance
    .post(API.ADJUST_BALANCE , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};


export const getInterFirmLedgerStatementData = (data={}) => {
  return axiosInstance
    .post(API.GET_INTER_FIRM_LEDGER_STATEMENT , data)
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
        console.log(err);
      }
//      throw err;
    });
};
